<template>
    <b-card
            header-bg-variant="light"
            border-variant="light-dark"
            header-text-variant="dark"
            class="mt-3 mb-3">
        <template slot="header">
            Opgeslagen informatie:
        </template>

        <div class="row spec-row">
            <div class="col-md-4">
                <h5>Relatie:</h5>
            </div>
            <div class="col-md-8">
                <div class="spec-data-row mb-4">
                    <strong>Achtergrondinformatie:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ lead.event.contactInfo | placeholder('-') }}</div>
                    </b-alert>
                </div>
            </div>
        </div>
        <div class="row spec-row">
            <div class="col-md-4">
                <h5>Doel(groep):</h5>
            </div>
            <div class="col-md-8">
                <div class="spec-data-row">
                    <strong>Doel:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('target') | placeholder('-') }}</div>
                    </b-alert>

                </div>
                <div class="spec-data-row mb-4">
                    <strong>Doelgroep:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('targetAudience') | placeholder('-') }}</div>
                    </b-alert>
                </div>
            </div>
        </div>
        <div class="row spec-row">
            <div class="col-md-4">
                <h5>Evenement:</h5>
            </div>
            <div class="col-md-8">
                <div class="spec-data-row">
                    <strong>Evenementhistorie:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('eventHistory') | placeholder('-') }}</div>
                    </b-alert>
                </div>
                <div class="spec-data-row mb-4">
                    <strong>Evenementplanning toekomst:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('eventPlanning') | placeholder('-') }}</div>
                    </b-alert>
                </div>
            </div>
        </div>
        <div class="row spec-row">
            <div class="col-md-4">
                <h5>Beslissing:</h5>
            </div>
            <div class="col-md-8">
                <div class="spec-data-row">
                    <strong>Beslissingsfactoren:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('decisionFactors') | placeholder('-') }}</div>
                    </b-alert>
                </div>
                <div class="spec-data-row mb-4">
                    <strong>Beslissingsbevoegde:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('decisionMaker') | placeholder('-') }}</div>
                    </b-alert>
                </div>
            </div>
        </div>

        <div class="row spec-row">
            <div class="col-md-4">
                <h5>Overig:</h5>
            </div>
            <div class="col-md-8">
                <div class="spec-data-row">
                    <strong>Vervolgstappen:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('nextStep') | placeholder('-') }}</div>
                    </b-alert>
                </div>
                <div class="spec-data-row">
                    <strong>Budgetindicatie:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('budgetIndication') | placeholder('-') }}</div>
                    </b-alert>
                </div>
                <div class="spec-data-row">
                    <strong>Bijzonderheden:</strong>
                    <b-alert variant="secondary" class="p-2" show>
                        <div class="pre-wrap">{{ getExtra('remarks') | placeholder('-') }}</div>
                    </b-alert>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
    export default {
        components: {},
        props: {
            lead: {
                type: Object,
                required: false
            },
        },
        data() {
            return {}
        },
        computed: {},
        watch: {},
        mounted() {
        },
        methods: {
            getExtra(key) {
                if(!this.lead || !this.lead.event.hasOwnProperty('extra') || !this.lead.event.extra.hasOwnProperty(key)) {
                    return '';
                }
                return this.lead.event.extra[key];
            }
        }
    }
</script>